import { Injectable, inject } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private snackBar = inject(MatSnackBar);


  /**
   * showSuccess
   * @param message message to be shown on success notification
   * theClass param is to override default snackbar styling , class definition is in styles.scss
   */
  showSuccess(message: string): void {
    this.snackBar.open(message, 'Close', {
      duration: 3000,
      panelClass: ['success-notification'],
      verticalPosition: 'top',
      horizontalPosition: 'right',
      politeness: 'polite', // Screen reader announcement
      direction: 'ltr' // Text direction
    });
  }

  showError(message: string): void {
    this.snackBar.open(message, 'Close', {
      duration: 5000,
      panelClass: ['error-notification'],
      verticalPosition: 'top',
      horizontalPosition: 'right'
    });
  }

  showInfo(message: string): void {
    this.snackBar.open(message, 'Close', {
      duration: 3000,
      panelClass: ['info-notification'],
      verticalPosition: 'top',
      horizontalPosition: 'right'
    });
  }

  showWarning(message: string): void {
    this.snackBar.open(message, 'Close', {
      duration: 4000,
      panelClass: ['warning-notification'],
      verticalPosition: 'top',
      horizontalPosition: 'right'
    });
  }

  // Advanced configuration examples:

  /**
   * Show notification with custom duration (no auto-dismiss)
   */
  showPersistent(message: string, action: string = 'Dismiss'): void {
    this.snackBar.open(message, action, {
      duration: 0, // No auto-dismiss
      panelClass: ['persistent-notification'],
      verticalPosition: 'top',
      horizontalPosition: 'right'
    });
  }

  /**
   * Show notification with custom data
   */
  showWithData(message: string, customData: any): void {
    this.snackBar.open(message, 'Close', {
      duration: 3000,
      panelClass: ['custom-notification'],
      verticalPosition: 'top',
      horizontalPosition: 'right',
      data: customData // Pass custom data
    });
  }

  /**
   * Show notification with assertive announcement (high priority for screen readers)
   */
  showUrgent(message: string): void {
    this.snackBar.open(message, 'Close', {
      duration: 5000,
      panelClass: ['urgent-notification'],
      verticalPosition: 'top',
      horizontalPosition: 'center',
      politeness: 'assertive', // High priority announcement
      announcementMessage: 'Urgent notification: ' + message
    });
  }

  /**
   * Show notification in different position
   */
  showBottomLeft(message: string): void {
    this.snackBar.open(message, 'Close', {
      duration: 3000,
      panelClass: ['bottom-left-notification'],
      verticalPosition: 'bottom',
      horizontalPosition: 'left'
    });
  }
}
